import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_switch_off.svg';
import Icon, { IconProps } from './icon';

const IconSwitchOff = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconSwitchOff;
